config.$inject = ["$httpProvider", "$locationProvider", "$qProvider"];
export function config($httpProvider: ng.IHttpProvider, $locationProvider:ng.ILocationProvider, $qProvider: ng.IQProvider): void {
    $httpProvider.interceptors.push("httpInterceptor");
    $locationProvider.hashPrefix('');
    $qProvider.errorOnUnhandledRejections(false);
}
